import React from "react";
import {
  Text,
  Mark,
  Tooltip,
} from "@chakra-ui/react";


const HighlightedTextBox = ({ input = "", header, description , bgColor="yellow.200"}) => {
  return (
    <>
      {description ? header &&
        <Tooltip
          placement="top-start"
          label={description}
        >
          <Text fontSize="sm" mt={2}> {header} </Text>
        </Tooltip>
        :
        header && <Text fontSize="sm" mt={2}> {header} </Text>
      }
      <Text
        mt={2}
        minHeight="100px"
        border="1px"
        borderColor="gray.200"
        borderRadius="md"
        p={2}
        width="100%"
        whiteSpace="pre-wrap"
        overflowX="hidden"
        sx={{
          overflowWrap: "anywhere",
          wordBreak: "break-word",
        }}
      >
        <Mark
          bgColor={input && bgColor}
          px="1"
          rounded="xs"
          whiteSpace="inherit"
          sx={{
            boxDecorationBreak: "clone",
            WebkitBoxDecorationBreak: "clone",
          }}
        >
          {input}
        </Mark>
      </Text>
    </>
  )
};

export default HighlightedTextBox;
